/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schukos1Inputs */

const de__field_schukos1 = /** @type {(inputs: _Field_Schukos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SchuKos`)
};

/**

* @param {_Field_Schukos1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schukos1 = /** @type {((inputs?: _Field_Schukos1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schukos1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schukos1(inputs)
});
export { _field_schukos1 as "_field_schuKos" }